const orderLayers = layers => [...layers].sort((a, b) => (a.zIndex ?? a.props?.zIndex ?? 0) - (b.zIndex ?? b.props?.zIndex ?? 0));

export default orderLayers